import React from 'react';
import SpringMarkSvg from 'javascripts/components/SpringMarkSvg';
import cx from 'classnames';
import pluralize from 'pluralize';
import store from 'javascripts/store.js';
import {autorun, computed, observable} from 'mobx';
import {observer} from 'mobx-react';

@observer
class SpringMonthSelection extends React.Component {
  @observable editMode = store.iho.honoreeInfoIsPresent;

  @computed get amount() {
    return store.iho.giftDuration * store.donateForm.costPerPerson;
  }

  componentDidMount() {
    store.donateForm.amount = this.amount;

    autorun(() => {
      store.donateForm.amount = this.amount;
    });
  }

  amountFor = months => (
    months * store.donateForm.costPerPerson
  );

  colorFor = months => (
    {
      1: 'cw-spring-med-green',
      3: 'cw-spring-med-blue',
      6: 'cw-spring-peach',
    }[months]
  );

  rgbColorFor = months => (
    {
      1: 'rgb(0, 172, 127)',
      3: 'rgb(18, 127, 185)',
      6: 'rgb(232, 137, 119)',
    }[months]
  );

  handleMonthClick = (months) => {
    store.iho.modalOpen = true;
    store.iho.giftDuration = months;
  };

  selectedEditOption = months => this.editMode && (store.iho.giftDuration == months);

  renderMonthOption = (months) => {
    const unselectedSvgColor = 'rgb(193,193,187)';

    return (
      <div
        className={cx('bg-cw-white border border-grey-30 border-solid cursor-pointer flex flex-row md-flex-col md-mx-1 my-1 rounded relative', {[`border-${this.colorFor(months)}`]: this.selectedEditOption(months)})}
        onClick={() => this.handleMonthClick(months)}
      >
        {this.selectedEditOption(months) &&
          <div className={`selected-flag ${this.colorFor(months)}`} />
        }
        <div className='flex flex-col justify-center mx-auto px-1 py-2 side-with-badge'>
          <SpringMarkSvg monthsToFill={months} rgbColor={!this.editMode || this.selectedEditOption(months) ? this.rgbColorFor(months) : unselectedSvgColor} />
          <div className={cx('badge md-mt-1 z-10 badge-grey-40', {[`badge-${this.colorFor(months)}`]: (!this.editMode || this.selectedEditOption(months))})}>{`${this.wordFor(months)} ${pluralize('month', months, false)}`}</div>
        </div>

        <div className={cx('border-0 border-grey-30 border-l border-solid flex flex-col justify-center md-border-0 md-border-t md-px-3 md-py-2 px-1 py-2 side-with-price', {[`border-${this.colorFor(months)}`]: this.selectedEditOption(months)})}>
          <div>
            <span className={cx(`align-top currency-unit mr-px relative text-xs ${!this.editMode || this.selectedEditOption(months) ? 'text-cw-black' : 'text-grey-40'}`)}>{store.donateForm.currencyUnit}</span>
            <span className={`h20 ${!this.editMode || this.selectedEditOption(months) ? 'text-cw-black' : 'text-grey-40'}`}>{this.amountFor(months)}</span>
          </div>

          <div className='dotted-divider mx-auto my-1' />

          <p className={cx(`italic mx-auto ${!this.editMode || this.selectedEditOption(months) ? 'text-cw-black' : 'text-grey-40'}`)}>Brings clean water to {pluralize('person', months, true)}</p>
        </div>
      </div>
    );
  };

  wordFor = months => (
    {
      1: 'one',
      3: 'three',
      6: 'six',
    }[months]
  );

  render() {
    return(
      <>
        <div className='text-center'>
          <p className={cx(`p30 font-medium ${!this.editMode ? 'mt-2' : ''}`)}>Each month brings a lifetime of impact. How many would you like to&nbsp;gift?</p>

          <div className={cx(`flex flex-col justify-center md-flex-row mt-1 ${!this.editMode ? 'md-mt-2' : ''}`)}>
            {this.renderMonthOption(1)}
            {this.renderMonthOption(3)}
            {this.renderMonthOption(6)}
          </div>
        </div>
      </>
    );
  }
}

export default SpringMonthSelection;
